var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-switch',{attrs:{"loading":_vm.loading,"readonly":_vm.loading},on:{"change":_vm.switchPackageArchiving},model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}})}
var staticRenderFns = []

export { render, staticRenderFns }